import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import moment from 'moment';
import Badge from 'components/v2/Badge';
import CircleButton from 'components/v2/buttons/CircleButton';
import EditButton from 'components/v2/buttons/EditButton';
import ExclamationIcon from 'components/v2/icons/ExclamationIcon';
import ExternalLinkIcon from 'components/v2/icons/ExternalLinkIcon';
import { get } from 'lodash';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import { NEXT_ACTIONS_STATUS, NEXT_ACTION_COLOR } from 'constants/next-actions';
import { titleize } from 'underscore.string';
import { unescapeSpecialChars } from '../../../helpers/helper_functions';
import { COMPLETE_STOP } from '../../../constants/next-actions';
import { getTimezone } from '../../../helpers/stops';
import ExternalLink from '../../v2/ExternalLink';
export default function NextAction({ action, nextAction, actionType, isCustomerView, onNextActionClick, hideEdit, }) {
    var _a;
    const { t } = useTranslation();
    const status = NEXT_ACTIONS_STATUS[action.action];
    const shouldShowShipper = !isCustomerView && get(action, 'shipment.shipper._id', false);
    function shouldShowCarrier() {
        var _a, _b;
        if (isCustomerView) {
            return false;
        }
        return !!((_b = (_a = action === null || action === void 0 ? void 0 : action.shipment) === null || _a === void 0 ? void 0 : _a.carrier) === null || _b === void 0 ? void 0 : _b._id);
    }
    function handleNextActionClick() {
        onNextActionClick(action);
    }
    function getEquipmentIds(action) {
        var _a, _b;
        if (action.shipment.equipments)
            return action.shipment.equipments;
        if ((_b = (_a = action.nextStop) === null || _a === void 0 ? void 0 : _a.container) === null || _b === void 0 ? void 0 : _b.equipment_id)
            return [action.nextStop.container.equipment_id];
        return [];
    }
    function formatDate(date) {
        if (!date) {
            return '';
        }
        return moment(date)
            .tz(getTimezone(action.nextStop))
            .format('L LT');
    }
    const equipmentIds = getEquipmentIds(action);
    return (React.createElement("div", { className: "p-4" },
        React.createElement("div", { className: "sm:-mx-2 flex flex-wrap" },
            React.createElement("div", { className: "sm:px-2 mb-2 sm:mb-0" },
                React.createElement(Badge, { className: "w-40", color: NEXT_ACTION_COLOR[status], onClick: handleNextActionClick }, t(status))),
            React.createElement("div", { className: "sm:px-2 mb-2 sm:mb-0" },
                React.createElement(DescriptionListItem, { label: t('SHIPMENT_ID'), className: "mb-2" },
                    React.createElement("div", { className: "text-sm w-40" },
                        React.createElement("a", { className: "underline", href: `/shipments/${action.shipment._id}`, target: "_blank", rel: "noreferrer noopener" },
                            React.createElement("div", { className: "flex items-center space-x-1" },
                                React.createElement("span", null, action.shipment.shipment_id),
                                React.createElement(ExternalLinkIcon, { className: "w-4 h-4" })))))),
            React.createElement("div", { className: "sm:px-2 mb-2 sm:mb-0" },
                React.createElement(DescriptionListItem, { label: t('CONTAINER_HASH'), className: "mb-2" }, equipmentIds.map((equipmentId) => (React.createElement("div", { className: "text-sm w-40" }, equipmentId))))),
            shouldShowShipper && (React.createElement("div", { className: "w-48 mb-2 sm:mb-0 sm:px-2" },
                React.createElement(DescriptionListItem, { label: titleize(t('SHIPPER', { count: 1 })), className: "mb-2" },
                    React.createElement("div", { className: "flex items-center space-x-1 underline" },
                        React.createElement(ExternalLink, { className: "w-4 h-4", href: `/users/${action.shipment.shipper._id}`, title: unescapeSpecialChars(action.shipment.shipper.company_name), showIcon: true }))))),
            !isCustomerView && (React.createElement("div", { className: "w-48 mb-2 sm:mb-0 sm:px-2" }, shouldShowCarrier() && (React.createElement(DescriptionListItem, { label: titleize(t('CARRIER', { count: 1 })), className: "mb-2" },
                React.createElement("a", { href: `/users/${action.shipment.carrier._id}`, className: "underline", target: "_blank", rel: "noreferrer noopener" },
                    React.createElement("div", { className: "flex items-center space-x-1" },
                        React.createElement("span", null, unescapeSpecialChars(action.shipment.carrier.name)),
                        React.createElement(ExternalLinkIcon, { className: "w-4 h-4" }))))))),
            React.createElement("div", { className: "sm:px-2 flex-1 mb-2 sm:mb-2" },
                React.createElement(DescriptionListItem, { label: t('NEXT_ACTION'), className: "mb-2" },
                    React.createElement("div", { className: "text-sm" },
                        React.createElement("p", { className: classnames({
                                'font-medium': !!action.subActionMessage,
                            }) }, t(nextAction)),
                        action.subActionMessage && (React.createElement("p", { className: "italic" }, t(action.subActionMessage)))))),
            COMPLETE_STOP === actionType && (React.createElement("div", { className: "sm:px-2 flex-1 mb-2 sm:mb-2" },
                React.createElement(DescriptionListItem, { label: t('APPT_SCHEDULED'), className: "mb-2" },
                    React.createElement("span", { className: "text-sm w-40" }, formatDate((_a = action.nextStop) === null || _a === void 0 ? void 0 : _a.window_end))))),
            !hideEdit && (React.createElement("div", { className: "sm:px-2" },
                React.createElement(EditButton, { type: "button", size: "small", onClick: handleNextActionClick, title: t(action.action) }))))));
}
